import React from "react";
import { theme, Tooltip, Modal } from 'antd';
import {
  PlusCircleFilled,
  EditOutlined,
  ExclamationCircleOutlined,
  DeleteOutlined
} from '@ant-design/icons';
import ColorButton from "../../common/ColorButton";
import TSTable from "../../common/TSTable";
import { URL_CHEMICAL } from "../../constants/urls";
import { dateTimeToHumanString } from "../../frameworks/Util";
import ErrorMessages from "../../common/ErrorMessages";
import { DELETE, } from "../../frameworks/HttpClient";
import AddQualityChemicalTankModal from "./AddQualityChemicalTankModal";

export default function QualityChemicalTankList(props) {
  const [ errorMessages, setErrorMessages ] = React.useState(false);
  const [ chemicalTankTarget, setChemicalTankTarget] = React.useState(null);
  const tableRef = React.useRef(null);
  const {
    token: { colorSuccess },
  } = theme.useToken();


  const { token : { colorError, colorPrimary, colorWarning }} = theme.useToken();


  const columns = [
    {
      title: 'Action',
      dataIndex: '',
      width : 150,
      key: 'action',
      render: (_, original) => {
        return (
          <div 
            style={{textAlign:'center'}}
            onClick={(e) => {
              e.stopPropagation()
            }}
          >
            <Tooltip triger='hover' title="ลบแทงก์">
              <ColorButton 
                type='primary'
                override={colorError}
                icon={<DeleteOutlined />}
                style={{ margin : 5}}
                onClick={()=> confirm(original.name, original.id)} 
              />
            </Tooltip>
            <Tooltip triger='hover' title="แก้ไข">
              <ColorButton 
                type='primary'
                override={colorWarning}
                icon={<EditOutlined />}
                style={{ margin : 5}}
                onClick={()=> setChemicalTankTarget(original)} 
              />
            </Tooltip>
          </div>
      )}
    },
    {
      title: 'ชื่อแทงก์เก็บสารเคมี',
      dataIndex: 'name',
      key: 'name',
      searcher : true,
    },
    {
      title: 'ประเภท',
      dataIndex: 'has_meter',
      key: 'has_meter',
      render : (value) => value ? 'มิเตอร์' : 'แทงก์'
    },
    {
      title: 'รายละเอียด',
      dataIndex: 'note',
      key: 'note',
    },
    {
      title: 'วันที่สร้าง',
      dataIndex: 'created',
      key: 'created',
      render : (value) => dateTimeToHumanString(value)
    },
    {
      title: 'วันที่แก้ไขล่าสุด',
      dataIndex: 'updated',
      key: 'updated',
      render : (value) => dateTimeToHumanString(value)
    },
  ]

  const confirm = (title, value) => {
    Modal.confirm({
      title: `ลบแทงก์สารเคมีคุณภาพ - ${title}`,
      icon: <ExclamationCircleOutlined style={{ color : colorError}} />,
      content: 'คุณต้องการเปิดบ่อเพื่อผลิตใช่หรือไม่ ?',
      okText: 'ใช่',
      cancelText: 'ไม่ใช่',
      maskClosable: true,
      okButtonProps: {style: { backgroundColor : colorError}},
      onOk:async() => {
        await handleDeleteChemical(value)
        refreshData();
      },
      onConfirm: () => refreshData()
    });
  };

  const handleDeleteChemical = async(id) => {
    setErrorMessages(null)
    try {
      await DELETE(`${URL_CHEMICAL.QUALITY_CHEMICAL_TANK}${id}/`)
    } catch (error) {
      setErrorMessages(error.errorMessages)
    }
  }

  const refreshData = async() => {
    if(tableRef.current)(
      await tableRef.current.fetchWithoutResetPage()
    )
  }

  return(
    <div>
      <ErrorMessages message={errorMessages}/>
      <ColorButton
        type={'primary'}
        override={colorSuccess}
        style={{ float : 'right', marginBottom : 10}}
        icon={<PlusCircleFilled />} 
        onClick={() => setChemicalTankTarget('add')}>
          {"เพิ่มแทงก์เก็บสารเคมีคุณภาพ"}
      </ColorButton>

      <TSTable
        ref={tableRef}
        columns={columns}
        size={'small'}
        url={URL_CHEMICAL.QUALITY_CHEMICAL_TANK}
      />

      <AddQualityChemicalTankModal
        open={chemicalTankTarget ? true : false}
        onClose={() => setChemicalTankTarget(null)}
        onUpdate={() => {
          setChemicalTankTarget(null)
          refreshData();
        }}
        target={chemicalTankTarget}
      />
    </div>
  )
}